/**
 * @generated SignedSource<<690fa11ba7cdfec334d0d9b24deafc32>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type projectsList_projectsDirectoryV3_projectsRef$data = {
  readonly " $fragmentSpreads": FragmentRefs<"pagination_projectsDirectoryV3" | "resultsTable_projectsDirectoryV3">;
  readonly " $fragmentType": "projectsList_projectsDirectoryV3_projectsRef";
};
export type projectsList_projectsDirectoryV3_projectsRef$key = {
  readonly " $data"?: projectsList_projectsDirectoryV3_projectsRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"projectsList_projectsDirectoryV3_projectsRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isAdminSettingsContext"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isAvoidNavigationRedirectEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "projectsList_projectsDirectoryV3_projectsRef",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isAdminSettingsContext",
          "variableName": "isAdminSettingsContext"
        },
        {
          "kind": "Variable",
          "name": "isAvoidNavigationRedirectEnabled",
          "variableName": "isAvoidNavigationRedirectEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "resultsTable_projectsDirectoryV3"
    },
    {
      "kind": "FragmentSpread",
      "name": "pagination_projectsDirectoryV3"
    }
  ],
  "type": "JiraProjectConnection"
};

(node as any).hash = "d8180912bf3302d12c5f5cbc842d8802";

export default node;
